import React from "react";
import ConnectedCreateTeamHeader from "./ConnectedCreateTeamHeader";
import ConnectedCreateTeamFields from "./ConnectedCreateTeamFields";

const CreateTeamView = () => (
    // eslint-disable-next-line tailwindcss/classnames-order
    <div className="grid grid--justify-content-center">
        <ConnectedCreateTeamHeader />
        <ConnectedCreateTeamFields />
    </div>
);

export default CreateTeamView;
